import {
    setLoading,
    setSubscriptions,
    setSubscriptionDetails,
    clearSubscriptionDetails,
    setError,
    setPagination,
} from "./reducer";
import { getAllSubscriptions, getSubscriptionById } from "../../helpers/apis";

const normalizeListResponse = (response, pageSize) => {
    if (!response) return { data: [], pagination: null };

    return {
        data: response.data?.subscriptions || response.subscriptions || response.data || [],
        pagination: {
            ...(response.data?.pagination || response.pagination || {}),
            itemsPerPage: pageSize,
        }
    };
};

export const fetchAllSubscriptions =
    (config = {}) =>
        async (dispatch) => {
            try {
                dispatch(setLoading(true));

                const limit = config.limit || config.perPage || 10;
                const page = config.page || config.currentPage || 1;

                dispatch(setPagination({ page, pageSize: limit }));

                const sort = config.sort || config.order || "desc";

                const params = {
                    page,
                    perPage: limit,
                    search: config.search ?? "",
                    status: config.status ?? "",
                    planType: config.planType ?? "",
                    sort,
                };

                if (config.isDownload) {
                    params.isDownload = true;
                }

                const response = await getAllSubscriptions(params);

                if (response && (response.success || response.status === 1)) {
                    const normalized = normalizeListResponse(response, limit);
                    dispatch(setSubscriptions(normalized));
                    dispatch(setError(null));
                } else {
                    const errorMsg = response?.message || "Failed to fetch subscriptions";
                    dispatch(setError(errorMsg));
                    dispatch(setSubscriptions({ subscriptions: [], pagination: null }));
                }
            } catch (error) {
                dispatch(setError(error.message || "Failed to fetch subscriptions"));
                dispatch(setSubscriptions({ subscriptions: [], pagination: null }));
            } finally {
                dispatch(setLoading(false));
            }
        };

export const fetchSubscriptionById = (subscriptionId) => async (dispatch) => {
    if (!subscriptionId) {
        dispatch(setError("Invalid subscription identifier"));
        dispatch(clearSubscriptionDetails());
        return;
    }

    try {
        dispatch(setLoading(true));
        console.log("Fetching subscription with ID:", subscriptionId); // Debug log

        const response = await getSubscriptionById(subscriptionId);
        console.log("API Response:", response); // Debug log

        if (response && (response.success || response.status === 1)) {
            const detail =
                response.data?.subscription ||
                response.data ||
                response.subscription ||
                null;
            dispatch(setSubscriptionDetails(detail));
            dispatch(setError(null));
        } else {
            dispatch(setError(response?.message || "Subscription not found"));
            dispatch(clearSubscriptionDetails());
        }
    } catch (error) {
        console.error("Error fetching subscription:", error);
        dispatch(setError(error.message || "Failed to fetch subscription details"));
        dispatch(clearSubscriptionDetails());
    } finally {
        dispatch(setLoading(false));
    }
};